// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".coupon-link[data-v-d1bcbc02] {\n  color: #1890ff;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.coupon-link[data-v-d1bcbc02]:hover {\n  opacity: 75%;\n}", ""]);
// Exports
module.exports = exports;
